<!--
  Map builder building admin screen.
  @author crm4f / ab557z
-->

<template>
    
  <div class="buildingAdminContainer">
    <div class="buildingOptionsContainer">

      <div class="btn-group" role="group" aria-label="newItemOptions">
        <button type="button" :disabled="currentBuilding == null || currentBuilding?.buildingId == null || currentBuilding?.buildingName == null" class="btn btn-primary active btn-sm" @click="saveCurrentBuilding()">Save</button>
        <button type="button" :disabled="currentBuilding == null" class="btn btn-primary active btn-sm" @click="clearCurrentBuilding()">Cancel</button>
        <button type="button" :disabled="currentBuilding == null" class="btn btn-primary active btn-sm" @click="deleteCurrentBuilding()">Delete</button>
      </div>

      <div class="optionRow">
        <button style="width:auto !important" class="btn btn-primary active btn-sm" @click="createNewBuilding()">New Building</button>
        <select class="form-control-sm" v-model="currentBuilding" :disabled="currentBuilding?.newish" :class="{'inputDisabled' :currentBuilding?.newish}">
          <option v-for="(building,i) in buildings" :value="building" :key="i">{{ building.buildingName }}</option>
        </select>
        <br>
      </div>

      <!-- BUILDING ID -->
      <div v-if="currentBuilding !== null">
        <div class="optionRow">
          <div>
            <label for="id">Id:</label>
          </div>
          <input 
            id="id"
            :disabled="currentBuilding == null || !currentBuilding?.newish" 
            :class="{'inputDisabled' :currentBuilding == null || !currentBuilding?.newish}" 
            class="form-control-sm" 
            v-model="currentBuilding.buildingId"
            label="id"
            required
          />
          <br>
        </div>

        <!-- BUILDING NAME -->
        <div class="optionRow">
          <div>
            <label for="name">Name:</label>
          </div>
          <input 
            id="name"
            :disabled="currentBuilding == null"
            :class="{'inputDisabled' :currentBuilding == null}"
            class="form-control-sm"
            v-model="currentBuilding.buildingName"
            label="name"
            required
          />
          <br>
        </div>

        <!-- SHAPE -->
        <div class="optionRow">
          <div>
            <span>Shape:</span>
          </div>
          <div class="btn-group" role="group" aria-label="buildingShapeOptions">
            <button 
              @click="editBuildingShape()"
              v-if="!drawingMode"
              :disabled="currentBuilding?.shape == null" 
              type="button" 
              class="btn btn-primary active btn-sm">
              Edit
            </button>
            <button 
              @click="lockBuildingShape()"
              v-if="drawingMode"
              :disabled="currentBuilding?.shape == null" 
              type="button"
              class="btn btn-primary active btn-sm">
              Lock
            </button>
            <button 
              @click="clearBuildingShape()"
              :disabled="currentBuilding?.shape == null" 
              type="button"
              class="btn btn-primary active btn-sm">
              Clear
            </button>
          </div>
          <br>
        </div>

        <!-- SHOW LABEL AT ZOOM-->
        <div class="optionRow">
          <div>
            <label for="labelAtZoom">Show Label at Zoom:</label>
          </div>
          <input 
            id="labelAtZoom"
            :disabled="currentBuilding == null" 
            :class="{'inputDisabled' :currentBuilding == null}" 
            class="form-control-sm" 
            label="labelAtZoom" 
            v-model="currentBuilding.showLabelAtZoom"
            type="number"/>
          <br>
        </div>
        
        <hr>

        <!-- ROUTE-->
        <div class="optionRow">
          <div>
            <label for="route">Route:</label>
          </div>
          <select 
            @change="routeChanged()"
            id="route"
            class="form-control-sm"
            :disabled="currentBuilding == null" 
            :class="{'inputDisabled' :currentBuilding == null}" 
            v-model="currentBuilding.route" 
            label="route">
              <option v-for="(route,i) in routes" 
                :value="route" 
                :key="i"
              >
                {{route.routeName}}
              </option>
          </select>
          <br>
        </div>

        <!-- NODE-->
        <div class="optionRow">
          <div>
            <label for="node">Node:</label>
          </div>
          <select 
            id="node"
            :disabled="currentBuilding == null"
            :class="{'inputDisabled' :currentBuilding == null}" 
            class="form-control-sm" 
            v-model="currentBuilding.node" 
            label="node">
            <option v-for="(node,i) in nodes" 
              :value="node" 
              :key="i"
            >
              {{node.nodeName}}
            </option>
          </select>
          <br>
        </div>

        <!-- ENTRANCE -->
        <div class="optionRow">
          <div>
            <label for="entrance">Entrance:</label>
          </div>
          <select
            id="entrance"
            :disabled="currentBuilding == null"
            :class="{'inputDisabled' :currentBuilding == null}" 
            class="form-control-sm"
            v-model="currentBuilding.entrance" 
            label="entrance">
            <option v-for="(entrance,i) in entrances" 
              :value="entrance" 
              :key="i"
            >
              {{entrance.featureName}}
            </option>
          </select>
          <br>
        </div>

        <hr>

        <!-- DIRECTIONS -->
        <div class="optionRow">
          <div>
            <label for="dirs">Directions:</label>
          </div>
          <textarea
            id="dirs"
            :disabled="currentBuilding == null"
            :class="{'inputDisabled' :currentBuilding == null}" 
            class="form-control-sm"
            v-model="currentBuilding.directions"  
            label="dirs"
          />
          <br>
        </div>

        <!-- ACCESS URL -->
        <div class="optionRow">
          <div>
            <label for="accessUrl">Access URL:</label>
          </div>
          <input 
            id="accessUrl"
            :disabled="currentBuilding == null" 
            :class="{'inputDisabled' :currentBuilding == null}" 
            class="form-control-sm" 
            label="accessUrl" 
            v-model="currentBuilding.accessUrl" 
          />
          <br>
        </div>

        <!-- DISPLAY ORDER -->
        <div class="optionRow">
          <div>
            <label for="displayOrder">Display Order:</label>
          </div>
          <input 
            id="displayOrder"
            :disabled="currentBuilding == null" 
            :class="{'inputDisabled' :currentBuilding == null}" 
            class="form-control-sm" 
            label="displayOrder" 
            v-model="currentBuilding.displayOrder"
            type="number"
          />
          <br>
        </div>

        <!-- ENTRY LEVEL -->
        <div class="optionRow">
          <div>
            <label for="entryLevel">Entry Level:</label>
          </div>
          <input 
            id="entryLevel"
            :disabled="currentBuilding == null" 
            :class="{'inputDisabled' :currentBuilding == null}" 
            class="form-control-sm" 
            label="entryLevel" 
            v-model="currentBuilding.entryLevel" 
            type="number"
          />
          <br>
        </div>

        <!-- ROOM TO ROOM DIRECTIONS? -->
        <div class="optionRow">
          <div>
            <label for="r2r">Room to room directions?</label>
          </div>
          <input 
            id="r2r"
            :disabled="currentBuilding == null" 
            :class="{'inputDisabled' :currentBuilding == null}" 
            class="form-control-sm" 
            label="r2r" 
            v-model="currentBuilding.roomToRoom" 
            type="checkbox"
          />
          <br>
        </div>
    </div>

    <div style="color: #003865; margin-top: 25%" v-else>
      <h1 class="display-5">Select or create a building to begin editing...</h1>
      <font-awesome-icon style="font-size: 50px;" icon="fa-solid fa-building-circle-exclamation" />
    </div>

    </div>

    <div class="gmapContainer">
      <GMapMap
        :center='DEFAULT_CAMPUS_LATLNG'
        :zoom='17'
        class='mapCanvas tallMap'
        id="campusMap"
        ref='mapRef'
        style="width: 100%; height: 100vh"
        :options='{
          styles: getStyles(),
          fullscreenControl: false,
          mapTypeControl: false,
          mapTypeControlOptions: {
            position: google && google.maps.ControlPosition.TOP_LEFT,
            style: google && google.maps.MapTypeControlStyle.DROPDOWN_MENU
          },
          streetViewControl: true,
          zoomControl: true
        }'
      >
        <!-- NODE MARKER -->
        <GMapMarker v-if="currentBuilding !== null && currentBuilding.node !== null"
          ref="nodeMarker"
          :position="{lat: Number(currentBuilding.node.lat), lng: Number(currentBuilding.node.lng)}"
          :clickable="true"
          :draggable="false"
          :icon="{
            url: require('@/assets/blue-dot.png'),
            scaledSize: {width: 13, height: 13},
          }"
          @click="openNodeInfoWindow(currentBuilding.node.nodeId)"
        >
          <GMapInfoWindow @closeclick="openNodeInfoWindow(null)" :closeclick="true" :opened="currentBuilding.node.nodeId == openedNodeInfoWindow">
            <div>
              {{ currentBuilding.node.nodeName }}
            </div>
          </GMapInfoWindow>
        </GMapMarker> 

        <!-- BUILDING MARKER -->
        <GMapMarker v-if="currentBuilding !== null"
        ref="buildingMarker"
        :position="determinePos(currentBuilding)"
        :clickable="true"
        :draggable="false"
        @click="openBuildingInfoWindow(currentBuilding.buildingId)"
        >
          <GMapInfoWindow @closeclick="openBuildingInfoWindow(null)" :closeclick="true" :opened="currentBuilding.buildingId == openedBuildingInfoWindow">
            <div>
              {{ currentBuilding.buildingName }}
            </div>
          </GMapInfoWindow>
        </GMapMarker>

        <!-- POLYLINES FOR SELECTED ROUTE -->
        <GMapPolyline v-bind:key="index" v-for="leg, index in currentBuilding?.routeLegs"
        :path="[{ lat: Number(leg.leg.nodeFrom.lat), lng: Number(leg.leg.nodeFrom.lng) }, { lat: Number(leg.leg.nodeTo.lat), lng: Number(leg.leg.nodeTo.lng) }]"
        :editable="false"
        :options="{
          strokeColor: '#908ebb',
          strokeWeight: 7
        }"
        ref='routePolyline'
        />

      </GMapMap>
    </div>

  </div>
</template>
  
<script setup>

import { onMounted, onBeforeUnmount, ref, shallowRef, toRaw, watch } from 'vue'
import { DrawingBoard } from './DrawingBoard.js'
import axios from 'axios'
 
const DEFAULT_CAMPUS_LATLNG = { lat: 55.872336, lng: -4.288118 }
 
const buildings = ref(null)
const currentBuilding = ref(null)
const routes = ref(null)
const nodes = ref(null)
const entrances = ref(null)
const drawingMode = ref(false)
const openedNodeInfoWindow = ref(null)
const openedBuildingInfoWindow = ref(null)
 
const mapRef = ref(null)
// shallowRef: never wrap the Google map object in a reactive Proxy.
const map = shallowRef(null)
const google = shallowRef(null)
 
// Non-reactive: the Terra Draw wrapper must stay raw.
let drawingBoard = null
 
onMounted(() => {
  getBuildings()
  getRoutes()
  getNodes()
  getEntrances()
 
  mapRef.value.$gmapApiPromiseLazy().then((gmapApi) => {
    google.value = gmapApi
    return mapRef.value.$mapPromise
  }).then((mapResponse) => {
    const gmap = toRaw(mapResponse)
    map.value = gmap
    // The Terra Draw Google adapter needs the map's inner DOM to exist,
    // which only happens after the first render, wait for 'idle'.
    google.value.maps.event.addListenerOnce(gmap, 'idle', () => {
      drawingBoard = new DrawingBoard(gmap, (path) => {
        if (currentBuilding.value !== null) {
          currentBuilding.value.shape = path
        }
      }, google.value)
      // A building may already have been picked while the map was loading.
      if (currentBuilding.value !== null) {
        buildingChanged()
      }
    })
  })
})
onBeforeUnmount(() => {
  if (drawingBoard) {
    drawingBoard.destroy()
  }
})
 
watch(currentBuilding, () => {
  buildingChanged()
})

/**
   * Method to open/track info windows for the node markers.
*/
 
function openNodeInfoWindow (nodeId) {
  openedNodeInfoWindow.value = nodeId
}
 

function openBuildingInfoWindow (buildingId) {
  openedBuildingInfoWindow.value = buildingId
}
 
/**
 * Building change handler. Resets the form and the map,
 * then triggers route changes.
 */
function buildingChanged () {
  drawingMode.value = false
 
  // Map not ready yet, the 'idle' listener will call us again.
  if (drawingBoard === null) {
    routeChanged()
    return
  }
 
  drawingBoard.clear()
  if (currentBuilding.value === null) {
    drawingBoard.lock()
  } else {
    if (!currentBuilding.value.newish && currentBuilding.value.entrance) {
      map.value.panTo({ lat: Number(currentBuilding.value.entrance.lat), lng: Number(currentBuilding.value.entrance.lng) })
    } else {
      map.value.panTo(DEFAULT_CAMPUS_LATLNG)
    }
 
    if (currentBuilding.value.shape == null) {
      drawingBoard.showTools()
    } else {
      drawingBoard.draw(currentBuilding.value.shape)
    }
  }
  routeChanged()
}
 
function routeChanged () {
    /*
      Keep a reference to the building node.
      Clearing the node list may cause a node change event setting the value to null. 
    */
  var node = currentBuilding.value?.node
  if (currentBuilding.value != null && currentBuilding.value?.route != null) {
    axios.get('map/admin/routes/' + currentBuilding.value.route.routeId + '/legs')
      .then((response) => {
        let routeLegs = response.data
        currentBuilding.value.routeLegs = routeLegs
        nodes.value = []
        for (var x = 0; x < routeLegs.length; x++) {
          nodes.value.push(routeLegs[x].leg.nodeFrom)
          if (x == routeLegs.length - 1) {
            nodes.value.push(routeLegs[x].leg.nodeTo)
          }
        }
        currentBuilding.value.node = node
      })
  }
}
 
function editBuildingShape () {
  if (drawingBoard === null) return
  drawingMode.value = true
  drawingBoard.edit()
}
 
function clearBuildingShape () {
  if (drawingBoard === null) return
  if (confirm('Are you sure?')) {
    drawingMode.value = false
    drawingBoard.clear()
    drawingBoard.showTools()
    currentBuilding.value.shape = null
  }
}
 
function lockBuildingShape () {
  if (drawingBoard === null) return
  drawingMode.value = false
  drawingBoard.lock()
}
 
function createNewBuilding () {
  currentBuilding.value = null
  axios.post('map/admin/buildings')
    .then((response) => {
      const building = response.data
      building.newish = true
      buildings.value.push(building)
      currentBuilding.value = building
    })
}
 
function clearCurrentBuilding () {
  if (confirm('Cancel current building edit?')) {
    currentBuilding.value = null
  }
}
 
function saveCurrentBuilding () {
  axios.put('map/admin/buildings', currentBuilding.value)
    .then(response => {
      if (response.status == 200) {
        alert('Update successful.')
        currentBuilding.value.newish = false
      } else if (response.status == 401 || response.status == 403) {
        alert('You are not authenticated. Check console for details.')
      } else {
        alert('Something unexpected happened. Check console for details')
      }
    })
}
 
function deleteCurrentBuilding () {
  if (confirm('Are you sure?')) {
    axios.delete('map/admin/buildings/' + currentBuilding.value.buildingId)
      .then((response) => {
        if (response.status == 200) {
          alert('Building deleted successfully.')
        } else if (response.status == 401 || response.status == 403) {
          alert('You are not authenticated. Check console for details.')
        } else {
          alert('Something unexpected happened. Check console for details')
        }
        currentBuilding.value = null
        getBuildings()
      })
  }
}
 
function getBuildings () {
  axios.get('map/admin/buildings', { withCredentials: false })
    .then(response => {
      buildings.value = response.data
    })
}
 
function getRoutes () {
  axios.get('map/admin/routes', { withCredentials: false })
    .then(response => {
      routes.value = response.data
    })
}
 
function getNodes () {
  axios.get('map/admin/nodes', { withCredentials: false })
    .then(response => {
      nodes.value = response.data
    })
}
 
function getEntrances () {
  axios.get('map/admin/features/entrances', { withCredentials: false })
    .then(response => {
      entrances.value = response.data
    })
    .catch((error) => {
      console.error(error.statusText)
    })
}
 
function determinePos (location) {
  var loc = toRaw(location)
  if ((loc?.entrance?.lat != null) && (loc?.entrance?.lng != null)) {
    return { lat: Number(loc.entrance.lat), lng: Number(loc.entrance.lng) }
  } else {
    return DEFAULT_CAMPUS_LATLNG
  }
}
 
function getStyles () {
  return [
    { featureType: 'road', elementType: 'geometry', stylers: [{ lightness: 100 }, { visibility: 'simplified' }] },
    { featureType: 'road', elementType: 'labels.text.fill', stylers: [{ color: '#575656' }] },
    { featureType: 'road', elementType: 'labels.text.stroke', stylers: [{ color: '#FFFFFF' }] },
    { featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] }
  ]
}


</script>
  
<style scoped>

.buildingAdminContainer {
  display: flex;
}

.gmapContainer {
  width: 100%;
  padding: 10px;
  height: fit-content;
}

.listHeader {
  color: #003865;
  font-weight: bold;
}

.hrhalfheight {
  width: 75%;
  margin: auto;
}

.feature-list {
  margin-bottom: 15px;
}

.inputDisabled {
  cursor: not-allowed;
}

.showFeatures, .showFeatures button {
  width: 100%;
}

.featuresContainer {
  margin-top: 15px;
}

.buildingOptionsContainer {
  padding: 25px 0px 10px 10px;
  width: 60%;
}

.optionRow {
  display: flex;
  margin: 10px 0px 0px 5px;
  align-items: center;
  justify-content: space-between;
}

.optionRow > :nth-child(1) {
  margin-right: 15px;
  width: 25%;
  text-align: left;
  word-break: break-word;
  font-size: 13px;
  font-weight: bold;
}

.optionRow > :nth-child(2) {
  flex: 1;
  width: 100% !important;
}

</style>